module.exports = __webpack_public_path__ + "img/tejarat-card-image.f19ec498.png";